var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85 145C118.137 145 145 118.137 145 85C145 51.8629 118.137 25 85 25C51.8629 25 25 51.8629 25 85C25 118.137 51.8629 145 85 145Z",
    fill: "#8BF2CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M114.401 71.3C114.401 57.4 103.801 50.9 88.5008 50.9C76.8008 50.9 68.1008 56.1 62.0008 62.5L71.0008 73C75.5008 68.2 80.9008 64.6 88.5008 64.6C97.0008 64.6 100.401 67.3 100.401 71.9C100.401 75.5 98.9008 77.1 93.9008 79.4C82.6008 84.6 79.8008 90.5 79.8008 100H93.5008C93.8008 94.1 95.9008 91.8 104.301 87.8C109.101 85.5 114.401 80.6 114.401 71.3ZM95.2008 114.6C95.2008 110 91.3008 106.1 86.7008 106.1C82.1008 106.1 78.2008 110 78.2008 114.6C78.2008 119.2 82.1008 123.1 86.7008 123.1C91.3008 123.1 95.2008 119.2 95.2008 114.6Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.401 68.3C110.401 54.4 99.8008 47.9 84.5008 47.9C72.8008 47.9 64.1008 53.1 58.0008 59.5L67.0008 70C71.5008 65.2 76.9008 61.6 84.5008 61.6C93.0008 61.6 96.4008 64.3 96.4008 68.9C96.4008 72.5 94.9008 74.1 89.9008 76.4C78.6008 81.6 75.8008 87.5 75.8008 97H89.5008C89.8008 91.1 91.9008 88.8 100.301 84.8C105.101 82.5 110.401 77.6 110.401 68.3ZM91.2008 111.6C91.2008 107 87.3008 103.1 82.7008 103.1C78.1008 103.1 74.2008 107 74.2008 111.6C74.2008 116.2 78.1008 120.1 82.7008 120.1C87.3008 120.1 91.2008 116.2 91.2008 111.6Z",
    fill: "#4B27E0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.f01da328.svg";
export { ForwardRef as ReactComponent };